import { Action, Resource } from "../../casl/constants"
import CAN from '../../casl/can';
import { ACTION_STATUS, EMAIL_DELIVERY_STATUS } from "./DemandConstant";
import { isAction } from "@reduxjs/toolkit";
export const DIAMETER = "DIAMETER"
export const SIGTRAN = "SIGTRAN"
export const TRANSPORT = "TRANSPORT"
export const VOLTE = "VOLTE"
export const VOLTE_LABEL = "Destination Opening"
export const DNS = "DNS"
export const GRX = "GRX"
export const AMEND_SERVICE= "amendService"
export const UPDATE_VOLTE= "updateVolte"
export const OTHER_SERVICES="OTHERS"
export const INTERNAL = "internal"
export const CUSTOMER = "customer"
export const serviceStatusColor =  {
    '#FFF1BB': 'received',  
    '#FFE1AB': 'in-progress',
    '#D5F9FF': 'pending-customer-action',
    '#C7FFE6' : 'completed',
    '#D4D4D4' : 'on-hold',
    '#E8E8E8' : 'closed'
}
export const SERVICE_OPTIONS = {
    "avg_monthly_dtr_volumes" : "Avg Monthly DTR Volumes",
    "dns_number" : "How Many DNS",
    "avg_monthly_msu_volumes" : "Avg Monthly MSU Volumes",
    "top_destinations" : "Top Destinations",
    "allocated_capacity" : "Allocated Capacity",
    "type" : "Type",
    "connectivityServiceType" : "Connectivity Service Type",
    "direction" : "Direction",
    "roamingPartnerName" : "Roaming Partner Name",
    "roamingPartnerTadigId" : "Roaming Partner TADIG Code",
    "isExistingRoamingPartner" : "Is Existing Roaming Partner",
    "requestorOrganisationName":"Requestor Organisation Name",
    "requestorTadig":"Requestor TADIG Code",
    "requestorCountry":"Requestor Country"
    } 


export const MY_SERVICE_TABS = {
    "LIVE_SERVICES":"Live Services",
    // "MY_DEMANDS":"My Demands",
    "DEMANDS":"Demands",
}

export const SERVICE_STATUS_OPTIONS = [    
    { label: "Received", value: "received" },
    { label: "In Progress", value: "in-progress" },
    { label: "Pending Customer Action", value: "pending-customer-action" },
    { label: "Completed", value: "completed" },
    { label: "Closed", value: "closed" },
    { label: "On Hold", value: "on-hold" },
  ]

  export const SERVICE_REQUEST_OPTIONS = {
    "CREATE_NEW":"Create New Demand",
    "AMMEND_EXISTING_SERVICE":"Amend Existing Service"
}

export const LIVE_SERVICE_STATUS={
    "No_Shutdown":"No Shutdown",
    "Live":"Live",
    "Shutdown":"Shutdown",
}
export const DEMAND_STATUS = {
    received: "received",
    pendingcustomeraction: "pending-customer-action",
    completed: "completed",
    inprogress:"in-progress",
    closed:"closed",
    onhold:"on-hold",
     }

export const columnConfig = [
        { name: 'requestid', weight: 2  },
        { name: 'organisationlegalname', weight: 2  },
        { name: 'Service', weight: 6  },
        { name: 'region', weight: 2  },
        { name: 'country', weight: 2  },
        { name: 'requestor', weight: 2 },
        { name: 'submittedOn', weight: 2 },
        { name: 'lastUpdatedOn', weight: 2 },
        { name: 'progressStage', weight: 2 },
      ];

export const allCount = (count) => {
  const validCount = count && typeof count === "object" ? count : {};
  return Object.values(validCount).reduce((acc, value) => {
    return acc + (typeof value === "number" && !isNaN(value) ? value : 0);
  }, 0);
};

export const ALLOWED_IPX_LIVE_SERVICES = ['diameter', 'dns', 'grx', 'sigtran']
      
export const subTabs = {
  demands: "Demands",
  liveServices: "Live Services",
};

const actionRules = [
  {
    status: ACTION_STATUS.REVIEW_INITIATED,
    can: () => CAN(Action.REVIEW_DEMAND, Resource.D2C_DEMANDS),
    message: 'New demand raised. Review and proceed.',
  },
  {
    status: ACTION_STATUS.FEASIBILITY_INITIATED,
    can: () =>  CAN(Action.CREARE_FEASIBILITY, Resource.D2C_DEMANDS),
    message: 'Action required: Complete feasibility assessment.',
  },
  {
    status: ACTION_STATUS.FEASIBILITY_COMPLETED,
    can: () =>  CAN(Action.REVIEW_DEMAND, Resource.D2C_DEMANDS),
    message: 'Feasibility assessment is complete. Initiate floor pricing.',
  },
  {
    status: ACTION_STATUS.QUOTATION_FLOOR_PRICING_INITIATED,
    can: () =>CAN(Action.CREARE_FLOORPRICING, Resource.D2C_DEMANDS),
    message: 'Action required: Prepare floor pricing.',
  },
  {
    status: ACTION_STATUS.QUOTATION_MARGIN_INITIATED,
    can: () => CAN(Action.CREATE_ADD_MARGIN, Resource.D2C_DEMANDS),
    message: 'Action required: Create quotation',
  },
  {
    status: ACTION_STATUS.QUOTATION_CUSTOMER_APPROVAL_INITIATED,
    can: () => CAN(Action.APPROVE_QUOTATION, Resource.D2C_DEMANDS),
    message: 'Quotation shared. Review and proceed.',
  },
  {       
    status: ACTION_STATUS.ORDER_FORM_CREATION_INITIATED,
    can: () => CAN(Action.CREATE_DRAFT_ORDER_FORM, Resource.D2C_DEMANDS),
    message: 'Quotation approved. Order form preparation required.',
  },
  {
    status: ACTION_STATUS.ORDER_FORM_CUSTOMER_APPROVAL_INITIATED,
    can: () => CAN(Action.CREATE_UNSIGNED_ORDERFORM, Resource.D2C_DEMANDS),
    message: 'Order form review required.',
  },
  {
    status: ACTION_STATUS.ORDER_FORM_UNSIGNED_SAVED_BY_CUSTOMER,
    can: () => CAN(Action.CREATE_SIGNED_ORDERFORM, Resource.D2C_DEMANDS),
    message: 'Order form pending signature.',
  },
  {
    status: ACTION_STATUS.ORDER_FORM_CUSTOMER_SIGNED_COPY_UPLOADED,
    can: () => CAN(Action.TRIGGER_ORDERFORM_CONTACT_EMAIL, Resource.D2C_DEMANDS),
    message: 'Action required: Trigger email to VGEL Team',
  },
  {
    status: ACTION_STATUS.ORDER_FORM_LEGAL_CONTRACT_SENT,
    can: () =>  CAN(Action.SERVICE_PROVISIONING_INITIATOR, Resource.D2C_DEMANDS),
    message: 'Service provisioning initiation required.',
  },
  {
    status: ACTION_STATUS.PROVSIONING_INITIATED,
    can: () => CAN(Action.CREATE_SERVICE_PROVISIONING, Resource.D2C_DEMANDS),
    message: 'Service provisioning completion required.',
  },
  {
    status: ACTION_STATUS.BILLING_INITIATED,
    can: () => CAN(Action.CREATE_BILLING, Resource.D2C_DEMANDS),
    message: 'Initiate billing onboarding.',
  },
  // {
  //   status: ACTION_STATUS.BILLING_ONBOARDING_COMPLETED,
  //   can: () =>  CAN(Action.COMPLETE_DEMAND, Resource.D2C_DEMANDS),
  //   message: 'Action required: Confirm the service start date.',
  // },
];

// export function getActionConfig(actionStatus,isUserActionFlag,metadata) {

//   const isClosed = [ACTION_STATUS.DEMAND_CLOSED, ACTION_STATUS.DEMAND_CLOSED_BY_SYSTEM].includes(actionStatus);
//   const pending = metadata?.pendingActions;

//   if (!isClosed && pending?.isLegalContractUploaded === false &&
//       pending?.isContractSentToLegalTeam === EMAIL_DELIVERY_STATUS.SENT) 
//     {
//       const hasPermission = CAN(Action.UPLOAD_ORDERFORM_LEAGAL_CONTARCT_ATTACHMENT, Resource.D2C_DEMANDS);
//       return {
//         isAction: hasPermission,
//         actionMessage: hasPermission ? "Upload duly signed order form.": "",
//       };
//     }

//   if (isUserActionFlag) {
//     return {
//       isAction: true,
//       actionMessage: "Please provide the requested information to help us process your demand.",
//     };
//   }

//   const rule = actionRules.find(
//     rule => rule.status === actionStatus && rule.can()
//   );
//   return {
//     isAction: Boolean(rule),
//     actionMessage: rule?.message || '',
//   };
// }



export function getActionConfig(actionStatus, isUserActionFlag, metadata) {

  const isClosed = [ ACTION_STATUS.DEMAND_CLOSED, ACTION_STATUS.DEMAND_CLOSED_BY_SYSTEM,].includes(actionStatus);
  const pending = metadata?.pendingActions;
  const actions = [];

  const legalUploadCondition = !isClosed && pending?.isLegalContractUploaded === false && pending?.isContractSentToLegalTeam === EMAIL_DELIVERY_STATUS.SENT;
  if (legalUploadCondition) {
    const hasPermission = CAN(Action.UPLOAD_ORDERFORM_LEAGAL_CONTARCT_ATTACHMENT, Resource.D2C_DEMANDS);

    if (hasPermission) {
      actions.push({
        message: "Upload duly signed order form.",
        priority: 4,
      });
    }
  }

  const demandConfirmAction  = actionStatus === ACTION_STATUS.BILLING_ONBOARDING_COMPLETED && pending?.canEditServiceActivationDate === false && pending?.canConfirmServiceActivationDate === true
    if (demandConfirmAction) {
    const hasPermission =  CAN(Action.COMPLETE_DEMAND, Resource.D2C_DEMANDS);

    if (hasPermission) {
      actions.push({
        message: "Demand Completed - Proceed to Close",
        priority: 3,
      });
    }
  }

  if (isUserActionFlag) {
    actions.push({
      message:"Provide the required information to proceed.",
      priority: 2,
    });
  }

  const matchedRules = actionRules.filter(
    (rule) => rule.status === actionStatus && rule.can()
  );

  matchedRules.forEach((rule) => {
    actions.push({
      message: rule.message,
      priority: 1,
    });
  });
  actions.sort((a, b) => b.priority - a.priority);
  return {
    isAction: actions.length > 0,
    actions,
  };
}